import React, { useState } from "react";

function Chat({ session, closeSession }) {
  const [messageInput, setMessageInput] = useState("");
  const [messages, setMessages] = useState([]);

  const sendMessage = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/session/message`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id_session: session, message: messageInput }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      // Add a placeholder for the system response
      setMessages((prevMessages) => [
        ...prevMessages,
        { author: "user", message: messageInput },
        { author: "system", message: "" }, // Placeholder for the streaming response
      ]);

      let responseText = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        // Decode the chunk and append it to the response text
        responseText += decoder.decode(value, { stream: true });

        // Update the last system message with the new chunk
        setMessages((prevMessages) => {
          const updatedMessages = [...prevMessages];
          const lastMessageIndex = updatedMessages.length - 1;
          updatedMessages[lastMessageIndex] = {
            ...updatedMessages[lastMessageIndex],
            message: responseText,
          };
          return updatedMessages;
        });
      }

      setMessageInput("");
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const handleChangeInput = (e) => {
    setMessageInput(e.target.value);
  };

  const handleSend = (e) => {
    e.preventDefault();
    if (messageInput.trim()) {
      sendMessage();
    }
  };

  const handleCloseSession = async () => {
    closeSession();

    const response = await fetch(`${process.env.REACT_APP_API_URL}/session/close`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id_session: session }),
    });
  };

  return (
    <div>
      <form onSubmit={handleSend}>
        <input type="text" value={messageInput} onChange={handleChangeInput} />
        <button type="submit">Send</button>
      </form>
      <div className="chat-window">
        {messages.map((msg, index) => (
          <div key={index} className={`message ${msg.author}`}>
            {msg.message.split("\n").map((line, i) => (
              <React.Fragment key={i}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </div>
        ))}
      </div>
      <button onClick={handleCloseSession}>Close Session</button>
    </div>
  );
}

export default Chat;